import personal from '@views/personal/personal';
import userinfo from '@views/personal/userinfo';
import editnickname from '@views/personal/editnickname';
import myorders from '@views/personal/myorders';
import quitsuccess from '@views/personal/quitsuccess';
import orderdetail from '@views/personal/orderdetail';
import evaluation from '@views/personal/evaluation';
import myaccount from '@views/personal/myaccount';
import myredpack from '@views/personal/myredpack';
import mycoupon from '@views/personal/mycoupon';
import myaddress from '@views/personal/myaddress';
import invoiceinfo from '@views/personal/invoiceinfo';
import mycomments from '@views/personal/mycomments';
import mycollection from '@views/personal/mycollection';
import writeaddress from '@views/personal/writeaddress';

import publishsunhome from '@views/personal/publishsunhome';
import searchbeloworders from '@views/personal/searchbeloworders';
const personalRouter = [
	{
		path: 'personal',
		name: 'personal',
		// component: personal,
  		component: resolve => require(['@views/personal/personal'],resolve),
		meta:{
			title: '我的',
			id: '4',
			requireAuth: true
		},
	    children: []
	},{
	        path: 'userinfo',
	        name: 'userinfo',
	        // component: userinfo, //用户信息编辑
  			component: resolve => require(['@views/personal/userinfo'],resolve),
	        meta:{
				title: '个人信息',
				requireAuth: true
			}

	},{
	        path: 'editnickname',
	        name: 'editnickname',
	        // component: editnickname, //编辑用户昵称
  			component: resolve => require(['@views/personal/editnickname'],resolve),
	        meta:{
				title: '修改昵称',
				requireAuth: true
			}
	},{
	        path: 'myorders',
	        name: 'myorders',
	        // component: myorders, //我的订单
  			component: resolve => require(['@views/personal/myorders'],resolve),
	        meta:{
				title: '我的订单',
				requireAuth: true
			}
	},{
	        path: 'quitsuccess',
	        name: 'quitsuccess',
	        // component: quitsuccess, //申请后
  			component: resolve => require(['@views/personal/quitsuccess'],resolve),
	        meta:{
				title: '申请提交',
				requireAuth: true
			}
	},{
	        path: 'orderdetail',
	        name: 'orderdetail',
	        // component: orderdetail, //订单详情
  			component: resolve => require(['@views/personal/orderdetail'],resolve),
	        meta:{
				title: '订单详情',
				requireAuth: true
			}
	},{
	        path: 'evaluation',
	        name: 'evaluation',
	        // component: evaluation, //评价
  			component: resolve => require(['@views/personal/evaluation'],resolve),
	        meta:{
				title: '评价',
				requireAuth: true
			}
	},{
	        path: 'myaccount',
	        name: 'myaccount',
	        // component: myaccount, //我的账户
  			component: resolve => require(['@views/personal/myaccount'],resolve),
	        meta:{
				title: '我的账户',
				requireAuth: true
			}
	}
	,{
	        path: 'myredpack',
	        name: 'myredpack',
	        // component: myredpack, //我的红包
  			component: resolve => require(['@views/personal/myredpack'],resolve),
	        meta:{
				title: '我的红包',
				requireAuth: true
			}
	},{
	        path: 'mycoupon',
	        name: 'mycoupon',
	        // component: mycoupon, //我的优惠券
  			component: resolve => require(['@views/personal/mycoupon'],resolve),
	        meta:{
				title: '我的优惠券',
				requireAuth: true
			}
	},{
	        path: 'myaddress',
	        name: 'myaddress',
	        // component: myaddress, //收货地址
  			component: resolve => require(['@views/personal/myaddress'],resolve),
	        meta:{
				title: '收货地址',
				requireAuth: true
			}
	},{
	        path: 'invoiceinfo',
	        name: 'invoiceinfo',
	        // component: invoiceinfo, //发票信息
  			component: resolve => require(['@views/personal/invoiceinfo'],resolve),
	        meta:{
				title: '发票信息',
				requireAuth: true
			}
	},{
	        path: 'mycomments',
	        name: 'mycomments',
	        // component: mycomments, //我的评论
  			component: resolve => require(['@views/personal/mycomments'],resolve),
	        meta:{
				title: '我的评论',
				requireAuth: true
			}
	},{
	        path: 'mycollection',
	        name: 'mycollection',
	        // component: mycollection, //我的收藏
  			component: resolve => require(['@views/personal/mycollection'],resolve),
	        meta:{
				title: '我的收藏',
				requireAuth: true
			}
	}
	,{
	        path: 'writeaddress',
	        name: 'writeaddress',
	        // component: writeaddress, //填写地址
  			component: resolve => require(['@views/personal/writeaddress'],resolve),
	        meta:{
				title: '添加新地址',
				requireAuth: true
			}
	},{
			path:'publishsunhome',
	        name: 'publishsunhome',
	        // component: publishsunhome, //填写地址
  			component: resolve => require(['@views/personal/publishsunhome'],resolve),
	        meta:{
				title: '晒家分享',
				requireAuth: true
			}
	},{
			path:'searchbeloworders',
	        name: 'searchbeloworders',
	        // component: searchbeloworders, //填写地址
  			component: resolve => require(['@views/personal/searchbeloworders'],resolve),
	        meta:{
				title: '搜索线下订单',
			}
	}
]

export default personalRouter;


// WEBPACK FOOTER //
// ./src/router/personal/index.js